import isNode from '../modules/ajio-util/isNode';

function getPlpMetaData(pathname = '') {
  const listingPageRegex = new RegExp('/[s,c,b,search,find]/');
  const pageInfo = pathname.split(listingPageRegex);
  return { pageCategory: 'PLP', pageId: pageInfo[1] };
}

function addLeadingAndTrailingSlash(path = '') {
  if (typeof path !== 'string') return path;

  if (path === '/' || path === '') {
    return '/home/';
  }
  if (!path.startsWith('/')) {
    path = '/' + path;
  }
  if (!path.endsWith('/')) {
    path = path + '/';
  }

  return path;
}

function getPageInfo(pathname = '', luxe = false, ajiogram = false) {
  let returnResponse = {};
  pathname = pathname.toLowerCase();
  if (pathname.includes('/c/')) {
    returnResponse = getPlpMetaData(pathname);
    returnResponse = { ...returnResponse, pageType: 'CategoryListingPage', pageName: 'CategoryListingPage', cohortPageType: 'plp' };
  } else if (pathname.includes('/s/')) {
    returnResponse = getPlpMetaData(pathname);
    returnResponse = { ...returnResponse, pageType: 'CuratedListingPage', pageName: 'CuratedListingPage', cohortPageType: 'plp' };
  } else if (pathname.includes('/b/')) {
    returnResponse = getPlpMetaData(pathname);
    returnResponse = { ...returnResponse, pageType: 'BrandListingPage', pageName: 'BrandListingPage', cohortPageType: 'plp' };
  } else if (pathname.includes('/search/') || pathname.includes('/find/')) {
    returnResponse = getPlpMetaData(pathname);
    returnResponse = { ...returnResponse, pageType: 'SearchListingPage', pageName: 'SearchListingPage', cohortPageType: 'plp' };
  } else if (pathname.includes('/shop/')) {
    const listingPageRegex = new RegExp('/shop/');
    const pageInfo = pathname.split(listingPageRegex);
    returnResponse = { pageType: 'SHOP', pageId: pageInfo[1], pageName: pageInfo[1], cohortPageType: 'cms' };
  } else if (pathname.includes('/p/')) {
    const listingPageRegex = new RegExp('/p/');
    const pageInfo = pathname.split(listingPageRegex);
    returnResponse = { pageType: 'Product', pageId: pageInfo[1], otherInfo: pageInfo[0], pageName: 'Product', cohortPageType: 'pdp' };
  } else if (pathname.includes('/cart')) {
    returnResponse = { pageType: 'Cart', pageId: 'Cart', pageName: 'Cart', cohortPageType: 'cart' };
  } else if (pathname.includes('/wishlist')) {
    returnResponse = luxe
      ? { pageType: 'wishlist', pageId: 'wishlist', pageName: 'wishlist', cohortPageType: 'wishlist' }
      : { pageType: 'Wishlist', pageId: 'Wishlist', pageName: 'Wishlist', cohortPageType: 'wishlist' };
  } else if (pathname.includes('/shipping')) {
    returnResponse = { pageType: 'Shipping', pageId: 'Shipping', pageName: 'Shipping' };
  } else if (pathname.includes('/checkout')) {
    returnResponse = { pageType: 'Checkout', pageId: 'Checkout', pageName: 'Checkout' };
  } else if (pathname.includes('/order/confirm')) {
    returnResponse = { pageType: 'Thankyou', pageId: 'Thankyou', pageName: 'Thankyou' };
  } else if (pathname.includes('/brands')) {
    returnResponse = { pageType: 'brands', pageId: 'brands', pageName: 'brands', cohortPageType: 'cms' };
  } else if (pathname.includes('/my-account/order-details')) {
    returnResponse = {
      pageType: 'order management screen',
      pageId: 'consolidated order details screen',
      pageName: 'order management screen',
      cohortPageType: ''
    };
  } else if (pathname.includes('/my-account/orders')) {
    returnResponse = { pageType: 'order management screen', pageId: 'order_listing_screen', pageName: 'order management screen' };
  } else if (pathname.includes('/my-account')) {
    returnResponse = { pageType: 'myAccount', pageId: 'myAccount', pageName: 'myAccount' };
  } else if (pathname.includes('/explore')) {
    returnResponse = { pageType: 'explore', pageId: 'explore', pageName: 'explore', cohortPageType: 'cms' };
  }else if (pathname.includes('/post')) {
    returnResponse = { pageType: 'post screen', pageId: 'post screen', pageName: 'post screen', cohortPageType: 'cms' };
  }else if (pathname.includes('/brand')) {
    returnResponse = { pageType: 'brand screen', pageId: 'brand screen', cohortPageType: 'cms' };
  }
  else {
    returnResponse = luxe ? { pageType: 'hp', pageId: 'hp', pageName: 'hp', cohortPageType: 'cms' } :  ajiogram ? {pageType: 'feed screen', pageId:'feed screen', cohortPageType: 'cms'} : { pageType: 'HP', pageId: 'HP', pageName: 'HP', cohortPageType: 'cms' };
  }
  return returnResponse;
}

function getLuxePageInfo(pathname = '') {
  let returnResponse = {};
  pathname = pathname.toLowerCase();

  if (
    pathname.includes('/c/') ||
    pathname.includes('/s/') ||
    pathname.includes('/b/') ||
    pathname.includes('/search/') ||
    pathname.includes('/find/')
  ) {
    returnResponse = getPlpMetaData(pathname);
    returnResponse = { ...returnResponse, pageType: 'plp' };
  } else if (pathname.includes('/p/')) {
    const listingPageRegex = new RegExp('/p/');
    const pageInfo = pathname.split(listingPageRegex);
    returnResponse = { pageType: 'pdp', pageId: pageInfo[1], otherInfo: pageInfo[0] };
  } else if (pathname.includes('/cart')) {
    returnResponse = { pageType: 'cart', pageId: 'cart' };
  } else if (pathname.includes('/wishlist')) {
    returnResponse = { pageType: 'wishlist', pageId: 'wishlist' };
  } else if (pathname.includes('/shipping')) {
    returnResponse = { pageType: 'shipping', pageId: 'shipping' };
  } else if (pathname.includes('/checkout')) {
    returnResponse = { pageType: 'checkout', pageId: 'checkout' };
  } else if (pathname.includes('/order/confirm')) {
    returnResponse = { pageType: 'orderConfirmation', pageId: 'orderConfirmation' };
  } else if (pathname.includes('/brands')) {
    returnResponse = { pageType: 'brands', pageId: 'brands' };
  } else if (pathname.includes('/my-account/order-details')) {
    returnResponse = {
      pageType: 'order management screen',
      pageId: 'consolidated order details screen'
    };
  } else if (pathname.includes('/my-account/orders')) {
    returnResponse = { pageType: 'order management screen', pageId: 'order_listing_screen' };
  } else if (pathname.includes('/my-account')) {
    returnResponse = { pageType: 'myAccount', pageId: 'myAccount' };
  } else {
    returnResponse = { pageType: 'hp', pageId: 'hp' };
  }
  return returnResponse;
}

function isServerRendering() {
  let isServer = false;
  if (typeof isNode() !== 'undefined') {
    isServer = isNode();
  }
  return isServer;
}

function getParams(location = {}) {
  let params = {};
  const { pathname = '' } = location;
  const { pageType = '', pageId = '', otherInfo = '', pageCategory = '' } = getPageInfo(pathname);

  if (!isServerRendering() && localStorage.getItem('browserId')) {
    params = { ...params, BrowserId: localStorage.getItem('browserId') };
  }
  if (pageType) {
    params = { ...params, PageType: pageType };
  }
  if (pageId) {
    params = { ...params, PageId: pageId };
  }
  if (otherInfo) {
    params = { ...params, OtherInfo: otherInfo };
  }
  if (pageCategory) {
    params = { ...params, PageCategory: pageCategory };
  }

  return params;
}

function readQueryParameter(location = {}) {
  let { search = '' } = location;
  const returnObj = {};
  search = search.startsWith('?') ? search.substr(1) : search;
  const paramsArray = search.split('&');

  paramsArray.map(item => {
    const splittedItem = item.split('=');
    if (splittedItem[0]) {
      returnObj[splittedItem[0]] = splittedItem[1];
    }
  });
  return returnObj;
}

function isNavigatorDefined() {
  return typeof navigator !== 'undefined';
}

function getPageInfoForGTM(path = '', luxe = false, ajiogram = false) {
  let returnResponse = {};
  const pathname = path.toLowerCase();

  if (pathname.includes('/c/')) {
    returnResponse = { pageType: 'plp screen', pageName: 'CategoryListingPage plp' };
  } else if (pathname.includes('/s/')) {
    returnResponse = { pageType: 'plp screen', pageName: 'CuratedListingPage plp' };
  } else if (pathname.includes('/b/')) {
    returnResponse = { pageType: 'BrandListingPage', pageName: 'BrandListingPage' };
  } else if (pathname.includes('/search/') || pathname.includes('/find/')) {
    returnResponse = {
      pageType: 'plp screen',
      pageName: hasBrandPageCode() ? 'brand plp screen' : 'search plp screen'
    };
  } else if (pathname.includes('/shop/')) {
    const listingPageRegex = new RegExp('/shop/');
    const pageInfo = pathname.split(listingPageRegex);
    returnResponse = { pageType: 'SHOP', pageName: pageInfo[1] };
  } else if (pathname.includes('/p/')) {
    returnResponse = { pageType: 'pdp screen', pageName: 'pdp screen' };
  } else if (pathname.includes('/cart')) {
    returnResponse = { pageType: 'Cart', pageName: 'Cart' };
  } else if (pathname.includes('/wishlist')) {
    returnResponse = luxe
      ? { pageType: 'wishlist', pageName: 'wishlist' }
      : { pageType: 'Wishlist', pageName: 'Wishlist' };
  } else if (pathname.includes('/shipping')) {
    returnResponse = { pageType: 'Shipping', pageName: 'Shipping' };
  } else if (pathname.includes('/checkout')) {
    returnResponse = { pageType: 'Checkout', pageName: 'Checkout' };
  } else if (pathname.includes('/order/confirm')) {
    returnResponse = { pageType: 'Thankyou', pageName: 'Thankyou' };
  } else if (pathname.includes('/brands')) {
    returnResponse = { pageType: 'brands', pageName: 'brands' };
  } else if (pathname.includes('/my-account/order-details')) {
    returnResponse = {
      pageType: 'order management screen',
      pageName: 'order management screen'
    };
  } else if (pathname.includes('/my-account/orders')) {
    returnResponse = { pageType: 'order management screen', pageName: 'order management screen' };
  } else if (pathname.includes('/my-account')) {
    returnResponse = { pageType: 'myAccount', pageName: 'myAccount' };
  } else if (pathname.includes('/explore')) {
    returnResponse = { pageType: 'explore', pageName: 'explore' };
  } else if (pathname.includes('/post')) {
    returnResponse = { pageType: 'post screen', pageName: 'post screen' };
  } else if (pathname.includes('/brand')) {
    returnResponse = { pageType: 'brand screen', pageName: 'brand screen' };
  } else {
    returnResponse = ajiogram
      ? { pageType: 'feed screen', pageName: 'feed screen' }
      : { pageType: 'home screen', pageName: 'home screen' };
  }
  return returnResponse;
}

function hasBrandPageCode() {
  if (typeof window === 'undefined') return false;
  try {
    return !!new URLSearchParams(window.location.search || '').get('brandPageCode');
  } catch (e) {
    return false;
  }
}

function isMobile() {
  let mobileDevice = false;
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    mobileDevice = true;
  }
  return mobileDevice;
}

const MENU_PLP_PARAM = 'isMenuPlp=true';

// Homepage repo identifies the PLP entry point via itm_source instead of isMenuPlp.
const ITM_SOURCE_PLP_FLAGS = {
  banner: 'isBannerPlp',
  widget: 'isWidgetPlp',
  coupon: 'isCouponPlp'
};

// Menu links carry the entry point in the URL; a localStorage write on click would be
// wiped by the outgoing PLP's beforeunload.
function withMenuPlpParam(url) {
  if (!url || url === '#' || url === '/#' || url.includes(MENU_PLP_PARAM)) {
    return url;
  }
  const [path, hash = ''] = url.split('#');
  return `${path}${path.includes('?') ? '&' : '?'}${MENU_PLP_PARAM}${hash ? `#${hash}` : ''}`;
}

// Move it into localStorage and strip it from the address bar.
function syncPlpEntryFromUrl() {
  try {
    const { pathname = '', search = '', hash = '' } = window.location || {};
    let query = search;

    if (search.includes(MENU_PLP_PARAM)) {
      localStorage.setItem('isMenuPlp', 'true');

      // Cut out only this param so the rest keeps its exact encoding.
      query = query
        .replace(`?${MENU_PLP_PARAM}&`, '?')
        .replace(`&${MENU_PLP_PARAM}`, '')
        .replace(`?${MENU_PLP_PARAM}`, '');
    }

    // itm_source stays in the URL; only isMenuPlp gets stripped.
    const { itm_source: itmSource } = readQueryParameter({ search });
    const plpFlag = ITM_SOURCE_PLP_FLAGS[itmSource];
    if (plpFlag) {
      localStorage.setItem(plpFlag, 'true');
    }

    if (query !== search) {
      window.history.replaceState({}, '', `${pathname}${query}${hash}`);
    }
  } catch (e) {
    // Best effort; the flag is already stored.
  }
}

function isPlpFlagSet(key) {
  return localStorage.getItem(key) === 'true';
}

// Shared by the /c/, /s/ and /b/ listing pages; resolves in priority order.
function getPlpEntryScreenName(fallback) {
  syncPlpEntryFromUrl();
  if (isPlpFlagSet('isCouponPlp')) return 'coupon plp screen';
  if (isPlpFlagSet('isBannerPlp')) return 'banner plp screen';
  if (isPlpFlagSet('isWidgetPlp')) return 'widget plp screen';
  if (isPlpFlagSet('isMenuPlp')) return 'menu plp screen';
  return fallback;
}

function getPageNameForGA(path = '', luxe = false, ajiogram = false) {
  let returnResponse = {};
  const pathname = path.toLowerCase();

  if (pathname.includes('/c/')) {
    returnResponse = {
      pageType: 'plp screen',
      pageName:
        window.location.href.includes('isDynamicWidget=true') ||
        window.location.href.includes('isLimitedPLP=true') ||
        window.location.href.includes('isCuratedWidget=true')
          ? 'widget plp screen'
          : getPlpEntryScreenName('search plp screen')
    };
  } else if (pathname.includes('/s/')) {
    const isWidgetPlp =
      window.location.href.includes('isDynamicWidget=true') ||
      window.location.href.includes('isLimitedPLP=true') ||
      window.location.href.includes('isCuratedWidget=true');
    returnResponse = {
      pageType: 'plp screen',
      pageName: isWidgetPlp ? 'widget plp screen' : getPlpEntryScreenName('search plp screen')
    };
  } else if (pathname.includes('/b/')) {
    returnResponse = {
      pageType: 'BrandListingPage',
      pageName: getPlpEntryScreenName('brand plp screen')
    };
  } else if (pathname.includes('/search/') || pathname.includes('/find/')) {
    returnResponse = {
      pageType: 'plp screen',
      pageName: hasBrandPageCode() ? 'brand plp screen' : 'search plp screen'
    };
  } else if (pathname.includes('/shop/')) {
    const listingPageRegex = new RegExp('/shop/');
    const category = pathname.split(listingPageRegex)[1];
    const pageName =
      category !== 'stores' ? `landing screen/sis-${category}` : 'home landing screen';
    returnResponse = { pageType: 'SHOP', pageName };
  } else if (pathname.includes('/p/')) {
    returnResponse = { pageType: 'pdp screen', pageName: 'pdp screen' };
  } else if (pathname.includes('/cart')) {
    returnResponse = { pageType: 'Cart', pageName: 'bag screen' };
  } else if (pathname.includes('/wishlist')) {
    returnResponse = luxe
      ? { pageType: 'wishlist', pageName: 'closet screen' }
      : { pageType: 'Wishlist', pageName: 'closet screen' };
  } else if (pathname.includes('/shipping')) {
    returnResponse = { pageType: 'Shipping', pageName: 'shipping screen' };
  } else if (pathname.includes('/checkout')) {
    returnResponse = { pageType: 'Checkout', pageName: 'Checkout' };
  } else if (pathname.includes('/order/confirm')) {
    returnResponse = { pageType: 'Thankyou', pageName: 'order confirmation screen' };
  } else if (pathname.includes('/brands')) {
    returnResponse = { pageType: 'brands', pageName: 'brands' };
  } else if (pathname.includes('/my-account/order-details')) {
    returnResponse = {
      pageType: 'order management screen',
      pageName: 'order item details screen'
    };
  } else if (pathname.includes('/my-account/orders')) {
    returnResponse = { pageType: 'order management screen', pageName: 'order listing screen' };
  } else if (pathname.includes('/my-account')) {
    returnResponse = { pageType: 'myAccount', pageName: 'my account screen' };
  } else if (pathname.includes('/explore')) {
    returnResponse = { pageType: 'explore', pageName: 'explore' };
  } else if (pathname.includes('/post')) {
    returnResponse = { pageType: 'post screen', pageName: 'post screen' };
  } else if (pathname.includes('/brand')) {
    returnResponse = { pageType: 'brand screen', pageName: 'brand screen' };
  } else if (pathname.includes('/login/otp')) {
    returnResponse = { pageType: 'login', pageName: 'login - otp screen' };
  } else if (pathname.includes('/login')) {
    returnResponse = {
      pageType: 'login',
      pageName: isMobile() ? 'mobile - login/signup screen' : 'login/signup screen'
    };
  } else if (pathname.includes('/signup/otp')) {
    returnResponse = { pageType: 'signup', pageName: 'signup - otp screen' };
  } else if (pathname.includes('/signup')) {
    returnResponse = {
      pageType: 'signup',
      pageName: isMobile() ? 'mobile - login/signup screen' : 'login/signup screen'
    };
  } else if (pathname.includes('/selfcare')) {
    returnResponse = { pageType: 'selfcare', pageName: 'customer care - self care screen' };
  }  else if (pathname.includes('/membership')) {
    returnResponse = { pageType: 'subscription landing screen', pageName: 'subscription landing screen' };
  }else {
    returnResponse = ajiogram
      ? { pageType: 'feed screen', pageName: 'feed screen' }
      : { pageType: 'home screen', pageName: 'home landing screen' };
  }
  return returnResponse;
}

function clearExpiredCartAttributionMap() {
  if (typeof window === 'undefined') return;
  const stored = JSON.parse(localStorage.getItem('attributionToken') || '{}');
  const expiry = stored?.expiry || 0;
  if (Date.now() > expiry) {
    localStorage.removeItem('cartAttributionMap');
  }
}

function clearAttributionToken() {
  try {
    const stored = JSON.parse(localStorage.getItem('attributionToken') || '{}');
    if (!stored?.value || Date.now() >= stored.expiry) {
      localStorage.removeItem('attributionToken');
    }
  } catch (e) {
    localStorage.removeItem('attributionToken');
  }
}

function clearExpiredCopilotMap() {
  try {
    const map = JSON.parse(localStorage.getItem('copilotMap') || '{}');
    const now = Date.now();
    const cleaned = Object.fromEntries(
      Object.entries(map).filter(([, v]) => v?.expiry > now)
    );
    localStorage.setItem('copilotMap', JSON.stringify(cleaned));
  } catch {
    localStorage.removeItem('copilotMap');
  }
}


export {
  getPageInfo,
  getLuxePageInfo,
  getParams,
  readQueryParameter,
  isServerRendering,
  isNavigatorDefined,
  getPageInfoForGTM,
  getPageNameForGA,
  clearExpiredCartAttributionMap,
  clearAttributionToken,
  addLeadingAndTrailingSlash,
  clearExpiredCopilotMap,
  withMenuPlpParam
};
